import { getFamilyIds } from '@editor2/services/storeService';
import { ChangesStatus } from '@editor2/types/changesStatus';
import { type CourseState } from '@editor2/types/courseState';
import { NgTraditional } from '@editor2/types/ngTraditional';
import { type Page } from '@editor2/types/page';

import { getDeletedModifiedConflict } from '../helpers/createConflictHelper';
import { getUpdatedValuesAndConflicts } from '../helpers/detectConflictHelper';

export class PageConflictDetector {
	detectConflicts = (state: CourseState, node) => {
		const { family_id, elements, ...page } = node as Page;

		const pageElements = { elements: getFamilyIds(elements) };

		// if current is deleted, but incoming is modified
		if (state.changes.pages[family_id]?.includes(ChangesStatus.Deleted)) {
			const conflict = getDeletedModifiedConflict({
				attribute: 'pages',
				entityType: NgTraditional.Page,
				id: family_id,
				state,
				incoming: { ...page, ...pageElements, family_id }
			});

			state.conflicts = [...state.conflicts, conflict];
			return;
		}

		const initial = state.initialCourse.pages.entities[family_id];
		const current = state.pages.entities[family_id];
		const incoming = { family_id, ...page, ...pageElements };
		const attributes = { ...page, ...pageElements };

		const payload = { initial, current, incoming, attributes, state };

		const data = getUpdatedValuesAndConflicts(payload);
		return data;
	};

	applyDiffToInitial = ({ state, family_id, updatedInitial }) => {
		// don't update elements array if it wasn't defined yet
		const { elements, ...pageWithoutElements } = updatedInitial;
		const initElements = state.initialCourse.pages.entities[family_id]?.elements;

		state.initialCourse.pages.entities[family_id] = {
			family_id,
			...(initElements && updatedInitial),
			...(!initElements && pageWithoutElements)
		};
	};

	applyDiffToCurrent = ({ state, family_id, updatedCurrent }) => {
		const { elements, ...pageWithoutElements } = updatedCurrent;
		const currentElements = state.pages.entities[family_id]?.elements;

		state.pages.entities[family_id] = {
			family_id,
			...(currentElements && updatedCurrent),
			...(!currentElements && pageWithoutElements)
		};
	};

	applyConflict = ({ state, conflicts }) => {
		state.conflicts = [...state.conflicts, ...conflicts];
	};
}
